import {
  Tab as FumadocsTab,
  Tabs as FumadocsTabs,
} from "fumadocs-ui/components/tabs";
import { Children, isValidElement } from "react";
import type { ReactNode } from "react";

type TabProps = {
  title: string;
  children: ReactNode;
};

type TabsProps = {
  children: ReactNode;
};

function getTabTitles(children: ReactNode) {
  return Children.toArray(children).flatMap((child) =>
    isValidElement<TabProps>(child) ? [child.props.title] : [],
  );
}

export function Tabs({ children }: TabsProps) {
  return <FumadocsTabs items={getTabTitles(children)}>{children}</FumadocsTabs>;
}

export function Tab({ children, title }: TabProps) {
  return <FumadocsTab value={title}>{children}</FumadocsTab>;
}
